import RichText from '@eneco/components/RichText/RichText';
import { NotificationBox } from '@eneco/sparky';
import { useContent } from '@sitecore/common';
import { DashboardOverviewRendering } from '@sitecore/types/DashboardOverview';

import { StyledDashboardBlock } from './DashboardBlock';
import { DashboardLink } from './DashboardLink';

export const PaymentMethodChangeFailedCard = () => {
  const { fields } = useContent<DashboardOverviewRendering>();

  return (
    <StyledDashboardBlock>
      <NotificationBox
        title={fields.paymentMethodChangeFailedCard?.notification.value?.title}
        text={<RichText html={fields.paymentMethodChangeFailedCard?.notification.value?.content} />}
        variant={fields.paymentMethodChangeFailedCard?.notification.value?.variant}
        isAlert={false}
      />
      <DashboardLink
        emphasis="high"
        href={fields.paymentMethodChangeFailedCard?.showMoveFileLink.value.href}
        trackingComponentName="payment_method_change_failed_move_file_link"
        trackingComponentType="dashboard_link">
        {fields.paymentMethodChangeFailedCard?.showMoveFileLink.value.text}
      </DashboardLink>
    </StyledDashboardBlock>
  );
};
